import { render, staticRenderFns } from "./RegisterSignIn.vue?vue&type=template&id=19dd1372&"
import script from "./RegisterSignIn.vue?vue&type=script&lang=js&"
export * from "./RegisterSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports